import styled from 'styled-components';
import Label from 'components/library/Label';

export const ProductImageContainer = styled.div.withConfig({
  shouldForwardProp: (prop) => !['config'].includes(prop),
})<{
  config?: {
    // styling
    padding?: string;
    backgroundColor?: string;

    // flexbox layout
    flexGrow?: number;
    flexShrink?: number;
    flexBasis?: string;
  };
}>`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;

  width: 100%;
  height: 100%;

  padding: ${({ config }) => config?.padding || '0'};
  background-color: ${({ config }) => config?.backgroundColor || 'transparent'};
  border-radius: var(--radius--medium, 16px);
  overflow: hidden;

  flex-grow: ${({ config }) =>
    config?.flexGrow !== undefined ? config.flexGrow : 1};
  flex-shrink: ${({ config }) =>
    config?.flexShrink !== undefined ? config.flexShrink : 0};
  flex-basis: ${({ config }) => config?.flexBasis || '50%'};
`;

export const ProductImageWrapper = styled.div.withConfig({
  shouldForwardProp: (prop) => !['containerHeight'].includes(prop),
})<{
  containerHeight?: string;
}>`
  position: relative;
  width: 100%;
  height: ${({ containerHeight }) => containerHeight || '100%'};
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ProductCardLabel = styled(Label).withConfig({
  shouldForwardProp: (prop) =>
    !['pillColor', 'spacing', 'fontColor', 'position'].includes(prop),
})<{
  pillColor?: string;
  fontColor?: string;
  position?:
    | 'left'
    | 'right'
    | 'top-left'
    | 'top-right'
    | 'bottom-left'
    | 'bottom-right'
    | 'center'
    | 'top-center'
    | 'bottom-center';
  spacing?: string;
}>`
  position: absolute;
  z-index: 1;
  ${({ pillColor }) => pillColor && `background-color: ${pillColor};`}
  color: ${({ fontColor }) =>
    fontColor ? `var(--text-${fontColor})` : 'var(--text-primary)'};

  /* Position handling */
  ${({ position, spacing }) => {
    const defaultSpacing = spacing || 'calc(var(--spacing-8) / 8)';

    switch (position) {
      case 'top-left':
        return `top: ${defaultSpacing}; left: ${defaultSpacing};`;
      case 'top-right':
        return `top: ${defaultSpacing}; right: ${defaultSpacing};`;
      case 'bottom-left':
        return `bottom: ${defaultSpacing}; left: ${defaultSpacing};`;
      case 'bottom-right':
        return `bottom: ${defaultSpacing}; right: ${defaultSpacing};`;
      case 'center':
        return `top: 50%; left: 50%; transform: translate(-50%, -50%);`;
      case 'top-center':
        return `top: ${defaultSpacing}; left: 50%; transform: translateX(-50%);`;
      case 'bottom-center':
        return `bottom: ${defaultSpacing}; left: 50%; transform: translateX(-50%);`;
      case 'left':
        return `top: ${defaultSpacing}; left: ${defaultSpacing};`;
      case 'right':
        return `top: ${defaultSpacing}; right: ${defaultSpacing};`;
      default:
        return `top: ${defaultSpacing}; left: ${defaultSpacing};`;
    }
  }}
`;
